<template>
    <button class="botao-menu" 
        :type="tipo"><i :class="font_awesome_class"></i>&nbsp;{{ label }}</button>
</template>

<script>
export default {
    name: 'Botao',
    props: ['tipo', 'label', 'font_awesome_class']
}
</script>
